// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"b0028083","240":"7211080a","432":"b0aed212","459":"86910e63","483":"d0f80a70","530":"4357538a","532":"7100aa55","537":"d2ae6081","779":"a23f821e","806":"e31192ff","821":"7220960a","867":"3190794a","876":"60f9e3f2","965":"2881ec83"}[chunkId] + ".chunk.js";
};